module.exports = __webpack_public_path__ + "static/media/caption1.cf4d9828.png";